// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"homeSection_wrapper__2vAJt","volume":"homeSection_volume__3fUK2","button":"homeSection_button__20FwE"};